import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface customerPreferences {
    firstName: any,
    lastName: any,
    dob: any,
    genderId: any,
    phone: any,
    email: any,
    profileImageUrl: any,
    auditTrailId: any,
    isActive: boolean
}

interface CustomerPreferencesState {
    data: customerPreferences[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_CUSTOMER_PORT;
const MASTERURL = import.meta.env.VITE_API_CUSTOMER_URL;


// Diet Mapping Code
export const fetchDietPreferences = createAsyncThunk<customerPreferences[], void, { rejectValue: string }>(
    'customerPreferences/fetchDietPreferences',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: customerPreferences[] }>('/get_all_user_profile', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createDietPreferences = createAsyncThunk<customerPreferences, any, { rejectValue: string }>(
    'customerPreferences/createDietPreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: customerPreferences }>('create_customer_diet_type_map', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateDietPreferences = createAsyncThunk<customerPreferences, any, { rejectValue: string }>(
    'customerPreferences/updateDietPreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: customerPreferences }>('update_spice_level', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
// Allergence Mapping Code
export const fetchAllergencePreferences = createAsyncThunk<customerPreferences[], void, { rejectValue: string }>(
    'customerPreferences/fetchAllergencePreferences',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: customerPreferences[] }>('/get_all_user_profile', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createAllergencePreferences = createAsyncThunk<customerPreferences, any, { rejectValue: string }>(
    'customerPreferences/createAllergencePreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: customerPreferences }>('create_customer_allergen_map', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateAllergencePreferences = createAsyncThunk<customerPreferences, any, { rejectValue: string }>(
    'customerPreferences/updateAllergencePreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: customerPreferences }>('update_spice_level', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
// Cuisines Mapping Code
export const fetchCuisinesPreferences = createAsyncThunk<customerPreferences[], void, { rejectValue: string }>(
    'customerPreferences/fetchCuisinesPreferences',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: customerPreferences[] }>('/get_all_user_profile', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createCuisinesPreferences = createAsyncThunk<customerPreferences, any, { rejectValue: string }>(
    'customerPreferences/createCuisinesPreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: customerPreferences }>('create_customer_cusine_pref', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateCuisinesPreferences = createAsyncThunk<customerPreferences, any, { rejectValue: string }>(
    'customerPreferences/updateCuisinesPreferences',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: customerPreferences }>('update_spice_level', params, PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const customerPreferencesSlice = createSlice({
    name: 'customerPreferences',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as CustomerPreferencesState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchDietPreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDietPreferences.fulfilled, (state, action: PayloadAction<customerPreferences[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchDietPreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createDietPreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createDietPreferences.fulfilled, (state, action: PayloadAction<customerPreferences>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createDietPreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateDietPreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateDietPreferences.fulfilled, (state, action: PayloadAction<customerPreferences>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateDietPreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })


            // Allergence Mapping Code
            .addCase(fetchAllergencePreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllergencePreferences.fulfilled, (state, action: PayloadAction<customerPreferences[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchAllergencePreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createAllergencePreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createAllergencePreferences.fulfilled, (state, action: PayloadAction<customerPreferences>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createAllergencePreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateAllergencePreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateAllergencePreferences.fulfilled, (state, action: PayloadAction<customerPreferences>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateAllergencePreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })


            // Cuisines Mapping Code
            .addCase(fetchCuisinesPreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCuisinesPreferences.fulfilled, (state, action: PayloadAction<customerPreferences[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCuisinesPreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createCuisinesPreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCuisinesPreferences.fulfilled, (state, action: PayloadAction<customerPreferences>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createCuisinesPreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateCuisinesPreferences.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCuisinesPreferences.fulfilled, (state, action: PayloadAction<customerPreferences>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateCuisinesPreferences.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default customerPreferencesSlice.reducer;